module.exports = __webpack_public_path__ + "static/media/credit_cards_color.2a7e4633.svg";